import { render, staticRenderFns } from "./WizardContent.vue?vue&type=template&id=81c42608&scoped=true&"
import script from "./WizardContent.vue?vue&type=script&lang=js&"
export * from "./WizardContent.vue?vue&type=script&lang=js&"
import style0 from "./WizardContent.vue?vue&type=style&index=0&id=81c42608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c42608",
  null
  
)

export default component.exports